import { FunctionalComponent } from 'preact';
import Textarea from 'components/Input/components/Textarea';
import { useTranslation } from 'react-i18next';
import { FormLabel } from './FormLabel.styles';

const commentValidation = {
  maxLength: 500,
};

interface CommentInputProps {
  onUpdateComment: (comment: string) => void;
  comment: string;
}

export const CommentInput: FunctionalComponent<CommentInputProps> = ({
  onUpdateComment,
  comment,
}) => {
  const { t } = useTranslation();
  return (
    <div>
      <FormLabel htmlFor="return-comments">{t('RETURN_COMMENTS')}</FormLabel>
      <Textarea
        id="return-comments"
        rows={6}
        value={comment}
        onChange={(e) => onUpdateComment(e.target.value)}
        maxLength={commentValidation.maxLength}
      />
    </div>
  );
};
